/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './customer-footer.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../custom-menu/custom-menu.component.ngfactory';
import * as i5 from '../../../../app/shared/custom-menu/custom-menu.component';
import * as i6 from '../../../../app/shared/settings.service';
import * as i7 from '../../../../app/auth/current-user';
import * as i8 from '../../../../app/shared/customer-footer/customer-footer.component';
const styles_CustomerFooterComponent:any[] = [i0.styles];
export const RenderType_CustomerFooterComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_CustomerFooterComponent,data:{}});
export function View_CustomerFooterComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'container']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          6,'div',[['class','meta']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['Copyright © 2017, All Rights Reserved,'])),(_l()(),
          i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          2,'a',([] as any[]),[[1,'target',0],[8,'href',4]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,7).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'custom-menu',
          [['position','footer']],[[2,'hidden',(null as any)]],(null as any),(null as any),
          i4.View_CustomMenuComponent_0,i4.RenderType_CustomMenuComponent)),i1.ɵdid(245760,
          (null as any),0,i5.CustomMenuComponent,[i6.SettingsService,i7.CurrentUser],
          {position:[0,'position']},(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        const currVal_2:any = '/';
        _ck(_v,7,0,currVal_2);
        const currVal_5:any = 'footer';
        _ck(_v,11,0,currVal_5);
      },(_ck,_v) => {
        var _co:i8.CustomerFooterComponent = _v.component;
        const currVal_0:any = i1.ɵnov(_v,7).target;
        const currVal_1:any = i1.ɵnov(_v,7).href;
        _ck(_v,6,0,currVal_0,currVal_1);
        const currVal_3:any = _co.settings.get('branding.site_name');
        _ck(_v,8,0,currVal_3);
        const currVal_4:any = i1.ɵnov(_v,11).shouldHide;
        _ck(_v,10,0,currVal_4);
      });
}
export function View_CustomerFooterComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'customer-footer',
      [['id','customer-footer']],(null as any),(null as any),(null as any),View_CustomerFooterComponent_0,
      RenderType_CustomerFooterComponent)),i1.ɵdid(49152,(null as any),0,i8.CustomerFooterComponent,
      [i6.SettingsService],(null as any),(null as any))],(null as any),(null as any));
}
export const CustomerFooterComponentNgFactory:i1.ComponentFactory<i8.CustomerFooterComponent> = i1.ɵccf('customer-footer',
    i8.CustomerFooterComponent,View_CustomerFooterComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvY3VzdG9tZXItZm9vdGVyL2N1c3RvbWVyLWZvb3Rlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvY3VzdG9tZXItZm9vdGVyL2N1c3RvbWVyLWZvb3Rlci5jb21wb25lbnQudHMiLCJuZzovLy9FOi93YW1wNjQvd3d3L2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9jdXN0b21lci1mb290ZXIvY3VzdG9tZXItZm9vdGVyLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9zaGFyZWQvY3VzdG9tZXItZm9vdGVyL2N1c3RvbWVyLWZvb3Rlci5jb21wb25lbnQudHMuQ3VzdG9tZXJGb290ZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiY29udGFpbmVyXCI+XHJcbiAgICA8ZGl2IGNsYXNzPVwibWV0YVwiPjxzcGFuPkNvcHlyaWdodCAmY29weTsgMjAxNywgQWxsIFJpZ2h0cyBSZXNlcnZlZCw8L3NwYW4+IDxhIFtyb3V0ZXJMaW5rXT1cIicvJ1wiPnt7c2V0dGluZ3MuZ2V0KCdicmFuZGluZy5zaXRlX25hbWUnKX19PC9hPjwvZGl2PlxyXG4gICAgPGN1c3RvbS1tZW51IHBvc2l0aW9uPVwiZm9vdGVyXCI+PC9jdXN0b20tbWVudT5cclxuPC9kaXY+IiwiPGN1c3RvbWVyLWZvb3Rlcj48L2N1c3RvbWVyLWZvb3Rlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUF1QiwyQ0FDbkI7VUFBQTtVQUFBLGdCQUFrQjtVQUFBO01BQU0sMkVBQWtEO2lCQUFBLHVCQUFDO1VBQUE7VUFBQTtZQUFBO1lBQUE7Y0FBQTtrQkFBQTtjQUFBO1lBQUE7WUFBQTtVQUFBLHVDQUFBO1VBQUE7VUFBQSxlQUFzQix3Q0FBZ0Q7VUFBQSxhQUNqSjtVQUFBO3lFQUFBLFVBQUE7VUFBQTtVQUFBLHlDQUE2Qzs7UUFEaUM7UUFBSCxXQUFHLFNBQUg7UUFDOUQ7UUFBYixZQUFhLFNBQWI7OztRQUQyRTtRQUFBO1FBQUEsV0FBQSxtQkFBQTtRQUFzQjtRQUFBO1FBQ2pHO1FBQUEsWUFBQSxTQUFBOzs7O29CQ0ZKO01BQUE7d0NBQUEsVUFBQTtNQUFBOzs7In0=



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/shared/customer-footer/customer-footer.component.ngfactory.ts